import {Field} from 'formik';
import {Stack} from '@mantine/core';
import {FormikSelect, FormikTextInput} from '@flexinet/ui-components';

const stateOptions = [
    {value: '', label: 'All States'},
    {value: 'OPEN', label: 'Open'},
    {value: 'CLOSED', label: 'Closed'},
];

// FNP-534 / FNP-538: backend-supported filters (MeteringRecordsFilterInput = state,
// customerId, meterId, meterCode, periodStartFrom/To). The Period Start date range
// only narrows server-side when a Meter ID is also supplied (it maps to a key-range
// Query on meter-period-index) — the helper text makes that dependency explicit. The
// date inputs are plain ISO-8601 text fields (no extra date-picker dependency); the
// admin pastes/edits the bound, matching the rest of this read-only console.
export const FilterFormComponent = () => {
    return (
        <Stack gap='md' my='md'>
            <Field
                name='state'
                label='State'
                data={stateOptions}
                component={FormikSelect}
            />
            <Field
                name='customerId'
                label='Customer ID'
                component={FormikTextInput}
            />
            <Field
                name='meterId'
                label='Meter ID'
                description='Required to narrow by Period Start date range.'
                component={FormikTextInput}
            />
            <Field
                name='meterCode'
                label='Meter Code'
                placeholder='e.g. email.sent'
                component={FormikTextInput}
            />
            <Field
                name='periodStartFrom'
                label='Period Start From'
                placeholder='2026-06-01T00:00:00Z'
                description='ISO-8601. Applies only with a Meter ID.'
                component={FormikTextInput}
            />
            <Field
                name='periodStartTo'
                label='Period Start To'
                placeholder='2026-06-30T23:59:59Z'
                description='ISO-8601. Applies only with a Meter ID.'
                component={FormikTextInput}
            />
        </Stack>
    );
};
